export default __webpack_public_path__ + "static/media/Header-AR.e0be0d1a.png";